module.exports = __webpack_public_path__ + "static/media/75 - Fern Kinney - Love Me Tonight (Love, Love, Love).806428f7.mp3";